import { Component, OnInit,ViewChild } from '@angular/core';
import { ExpenseService} from 'app/shared/services/expense.service';
import { Expense } from 'app/shared/types/expense';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';


@Component({
  selector: 'app-expense-list',
  templateUrl: './expense-list.component.html',
  styleUrls: ['./expense-list.component.css']
})
export class ExpenseListComponent implements OnInit {

  isDark: boolean = false;

  displayedColumns: string[] = ['expNo', 'date','supName','paymentType', 'expTotal','status','createdBy','action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;

  expense : Expense[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  constructor(
    private expenseService :ExpenseService, 
    private router : Router, 
    private route : ActivatedRoute, 
    private toastr: ToastrService,
    private themeService: NbThemeService,
    private dialogService: DialogService,
    private authService: AuthService,
   ) { }

ngOnInit() {

    this.getAllExpenses();
    this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

}

getControlPermissions(){
  var data = [];
   data =  this.authService.controlPermissionArray.filter((el)=>{
    return el.moduleCode ==='EXP'
  });
  if(data.length > 0){
    this.crud_access.read = data[0].read;
    this.crud_access.create = data[0].create;
    this.crud_access.approve = data[0].approve;
    this.crud_access.delete = data[0].delete;
  }
}

newButtonClick(){
  this.router.navigate(['../expense'],{relativeTo : this.route});
  }


  getAllExpenses(){
  this.expenseService.getAll()
   .subscribe(
      (data) => {
                this.expense = data; 
                this.dataSource = new  MatTableDataSource (this.expense);  
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;      
                },
     (err) => 
              {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              });  
    
   }
 

   viewDetailsButtonClick(expNo:string){     
      this.router.navigate(['../expense'],{queryParams : {'expNo':expNo},relativeTo : this.route});       
   }

   deleteButtonClick(poNo : string){   
     this.dialogService.openConfirmDialog('Are you sure you want to delete this expense?')
     .afterClosed().subscribe(res =>{
       if(res){
      this.expenseService.deleteExpense(poNo)
      .subscribe(
        (res) => {
                    this.toastr.success('Expense deleted successfully','Success');
                    this.getAllExpenses();
                    console.log(res);     
                  },        
        (err) =>  {
                    this.toastr.error('Failed to delete expense','Failure');
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  }, 
          )

      } 
    });
 }


 applyFilter(){
  this.dataSource.filter =this.searchKey.trim().toLowerCase();

 }
 onSearchClear(){
   this.searchKey = "";
   this.applyFilter();
}



}//end class
